angular.module('zc.core')

.directive 'zcTermsOfServiceAppierJp', () ->
  restrict: 'E'
  templateUrl: '/templates/core/views/terms_of_service_appier_jp.html'



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/terms_of_service_appier_jp.directive.coffee